// Generated by ReScript, PLEASE EDIT WITH CARE

import * as JsxRuntime from "react/jsx-runtime";
import * as LargeProjectItem$BenfaerberBlog from "./LargeProjectItem.bs.js";
import * as SmallProjectItem$BenfaerberBlog from "./SmallProjectItem.bs.js";

function ProjectItem(props) {
  var project = props.project;
  if (props.size === "Small") {
    return JsxRuntime.jsx(SmallProjectItem$BenfaerberBlog.make, {
                project: project
              });
  } else {
    return JsxRuntime.jsx(LargeProjectItem$BenfaerberBlog.make, {
                project: project
              });
  }
}

var make = ProjectItem;

export {
  make ,
}
/* react/jsx-runtime Not a pure module */
